<div class="formgrid grid">
    <div class="col-12 md:col-12">
        <div *ngFor="let group of groupedData; let i = index">
            <h3>{{ group.title }}</h3>
            <hr />
            <div *ngIf="registro" class="tabla-card">
                <p-table [value]="group.items" [paginator]="false" responsiveLayout="stack"
                    styleClass="p-datatable-gridlines" [tableStyle]="{ 'min-width': '50rem' }">
                    <ng-template pTemplate="body" let-item>
                        <tr class="tr-body">
                            <td class="td-title-table-r-profesional">{{ item.label }}</td>
                            <td>{{ item.formattedValue }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>